/* eslint-disable react/require-default-props */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/jsx-props-no-spreading */
// eslint-disable-next-line react/no-unstable-nested-components
import React, { useEffect, useMemo, useState } from 'react';
import { Box, Grid, Tab, Tabs } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import ProjectsTimeList from './ProjectsTimeList';
import InvoiceServiceTimes from './serviceTimes/InvoiceServiceTimes';
import InvoicesList from './invoices/InvoicesList';
import Notes from './Notes';
import DestinationAssignmentsCollapseList from './DestinationAssignmentsCollapseList';
import MarginDashboard from './MarginDashboard';
import Chat from '../../components/client/Chat';
import api from '../../api';
import { Project, Version } from '../../utils/types/ProjectType';
import VersionsList from './VersionsList';

interface TabPanelProps {
  children?: React.ReactNode;
  padding?: number;
  step: string;
  value: string;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, step, padding = 3, ...other } = props;
  return (
    <div
      aria-labelledby={`simple-tab-${step}`}
      hidden={value !== step}
      id={`simple-tabpanel-${step}`}
      role="tabpanel"
      {...other}
      style={{ width: '100%' }}
    >
      {value === step && (
        <Box className="tab-panel-box" sx={{ p: padding, width: '100%' }}>
          {children}
        </Box>
      )}
    </div>
  );
}

const TABS = {
  ASSIGNMENTS: 'assignments',
  CHAT: 'chat',
  DOCUMENTS: 'documents',
  HISTORY: 'versions',
  INVOICES: 'invoices',
  MARGIN_DASHBOARD: 'margin-dashboard',
  NOTES: 'notes',
  OPERATIONS: 'operations',
  SETUP: 'setup'
};
interface StepDetailProjectsProps {
  dayChecked: string;
  detailProject: Project;
  isClient?: boolean;
  onLoadVersion: (id: string) => void;
  projectType: string;
  refresh: () => void;
  typeView: string;
  utcUpadtedAt: string;
  versions: Version[];
}

const StepDetailProjects: React.FC<StepDetailProjectsProps> =
  function StepProjects({
    detailProject,
    utcUpadtedAt,
    typeView,
    dayChecked,
    projectType,
    refresh,
    isClient = false,
    versions,
    onLoadVersion
  }) {
    const { t } = useTranslation();
    const location = useLocation();
    const [step, setStep] = useState<string>(
      (location.state as any)?.tab || TABS.HISTORY
    );

    const countServices = useMemo(() => {
      return (
        detailProject?.proposal?.lead?.destinations
          ?.flatMap((destination) => destination.serviceTimes)
          ?.flatMap((serviceTime) => serviceTime.services)?.length || 0
      );
    }, [detailProject]);

    useEffect(() => {
      if (typeView && projectType === 'Regular') {
        setStep(TABS.HISTORY);
      }
    }, [typeView, projectType]);

    const headerProject = () => {
      return (
        <Box style={{ width: '100%' }}>
          <Tabs
            aria-label="project detail tabs"
            onChange={(_: React.SyntheticEvent, newValue: string) => {
              setStep(newValue);
            }}
            sx={{
              '& .MuiTab-root': {
                '&.Mui-selected': {
                  color: '#005DA2',
                  fontWeight: 600
                },
                color: '#7D8090',
                fontSize: '12px',
                fontWeight: 500,
                minHeight: 44,
                padding: '0 16px',
                textTransform: 'none'
              },
              '& .MuiTabs-indicator': {
                backgroundColor: '#005DA2',
                height: 2
              },
              backgroundColor: 'white',
              borderBottom: '1px solid #E2E4EA',
              minHeight: 44
            }}
            value={step}
          >
            <Tab label="Versions" value={TABS.HISTORY} />
            {projectType === 'Regular' && !isClient && (
              <Tab label={t('LISTING_PAGES.serviceSetup')} value={TABS.SETUP} />
            )}

            {projectType === 'Regular' && (
              <Tab
                label={t(
                  isClient
                    ? 'LISTING_PAGES.serviceAndTimes'
                    : 'LISTING_PAGES.serviceAndTask'
                )}
                value={TABS.OPERATIONS}
              />
            )}

            {projectType === 'Ad-Hoc' && (
              <Tab
                label={
                  <Box
                    sx={{ alignItems: 'center', display: 'flex', gap: '6px' }}
                  >
                    <span>{t('LISTING_PAGES.serviceAndTask')}</span>
                    <Box
                      sx={{
                        alignItems: 'center',
                        backgroundColor: '#005DA2',
                        borderRadius: '10px',
                        color: '#fff',
                        display: 'flex',
                        fontSize: '10px',
                        fontWeight: 700,
                        height: '18px',
                        justifyContent: 'center',
                        minWidth: '26px',
                        px: '6px'
                      }}
                    >
                      {countServices}
                    </Box>
                  </Box>
                }
                value={TABS.OPERATIONS}
              />
            )}
            <Tab
              label={t('LISTING_PAGES.invoices')}
              style={{ fontSize: '13px' }}
              value={TABS.INVOICES}
            />
            {!isClient && (
              <Tab
                label="Margin"
                style={{ fontSize: '13px' }}
                value={TABS.MARGIN_DASHBOARD}
              />
            )}
            {isClient && (
              <Tab label={t('LISTING_PAGES.chat')} value={TABS.CHAT} />
            )}

            {!isClient && (
              <Tab label={t('LISTING_PAGES.chatOperator')} value={TABS.CHAT} />
            )}

            {!isClient && (
              <Tab label={t('LISTING_PAGES.notes')} value={TABS.NOTES} />
            )}
            {!isClient && (
              <Tab label={t('GENERAL.assignments')} value={TABS.ASSIGNMENTS} />
            )}
          </Tabs>

          <Grid
            md={12}
            style={{
              backgroundColor: 'white',
              display: 'flex',
              flexDirection: 'row'
            }}
            xl={12}
            xs={12}
          >
            <TabPanel step={step} value={TABS.HISTORY}>
              <VersionsList
                detailProjectId={detailProject?.id}
                isClient={isClient}
                onLoadVersion={onLoadVersion}
                versions={versions}
              />
            </TabPanel>
            {projectType === 'Regular' ? (
              <>
                {!isClient && (
                  <TabPanel step={step} value={TABS.SETUP}>
                    <ProjectsTimeList
                      destinations={
                        detailProject?.proposal?.lead?.destinations || []
                      }
                      detailProjectId={detailProject?.id}
                      projectType={projectType}
                    />
                  </TabPanel>
                )}
                <TabPanel step={step} value={TABS.OPERATIONS}>
                  <InvoiceServiceTimes
                    dayChecked={dayChecked}
                    destinations={
                      detailProject?.proposal?.lead?.destinations || []
                    }
                    detailProjectId={detailProject?.id}
                    onLoadVersion={onLoadVersion}
                    projectName={detailProject?.proposal?.lead?.name}
                    projectType={projectType}
                    typeView={typeView}
                    utcUpadtedAt={utcUpadtedAt}
                    versions={versions}
                  />
                </TabPanel>
                <TabPanel step={step} value={TABS.INVOICES}>
                  <InvoicesList
                    detailProject={detailProject}
                    isClient={isClient}
                    onLoadVersion={onLoadVersion}
                    versions={versions}
                  />
                </TabPanel>
              </>
            ) : (
              <>
                <TabPanel step={step} value={TABS.OPERATIONS}>
                  <InvoiceServiceTimes
                    dayChecked={dayChecked}
                    destinations={
                      detailProject?.proposal?.lead?.destinations || []
                    }
                    detailProjectId={detailProject?.id}
                    onLoadVersion={onLoadVersion}
                    projectType={projectType}
                    typeView={typeView}
                    utcUpadtedAt={utcUpadtedAt}
                    versions={versions}
                  />
                </TabPanel>
                <TabPanel step={step} value={TABS.INVOICES}>
                  <InvoicesList
                    detailProject={detailProject}
                    isClient={isClient}
                    onLoadVersion={onLoadVersion}
                    versions={versions}
                  />
                </TabPanel>
              </>
            )}

            {!isClient && (
              <>
                <TabPanel step={step} value={TABS.MARGIN_DASHBOARD}>
                  <MarginDashboard
                    detailProjectId={detailProject?.id}
                    projectEndDate={
                      detailProject?.proposal?.lead?.projectEndDate
                    }
                    projectStartDate={
                      detailProject?.proposal?.lead?.projectStartDate
                    }
                  />
                </TabPanel>
                <TabPanel step={step} value={TABS.NOTES}>
                  <Notes id={detailProject?.id} />
                </TabPanel>
                <TabPanel padding={1} step={step} value={TABS.ASSIGNMENTS}>
                  <DestinationAssignmentsCollapseList
                    destinations={
                      detailProject?.proposal?.lead?.destinations || []
                    }
                    projectEndDate={
                      detailProject?.proposal?.lead?.projectEndDate
                    }
                    projectId={detailProject?.id}
                    projectStartDate={
                      detailProject?.proposal?.lead?.projectStartDate
                    }
                    projectStatus={detailProject?.status}
                    refresh={refresh}
                  />
                </TabPanel>
              </>
            )}

            <TabPanel padding={1} step={step} value={TABS.CHAT}>
              <Box sx={{ height: 520, overflow: 'scroll' }}>
                <Chat
                  apiToGetMessage={api.ProjectApi.projectGetMessages}
                  apiToPostMessage={
                    isClient
                      ? api.ProjectApi.postMessageProjectClientView
                      : api.ProjectApi.postMessageProjectOperator
                  }
                  clientView={isClient}
                  id={detailProject.id}
                />
              </Box>
            </TabPanel>
          </Grid>
        </Box>
      );
    };

    return (
      <Grid
        container
        spacing={2}
        style={{
          backgroundColor: 'white',
          borderLeft: '1px solid #ddd',
          height: '100%',
          marginTop: '-16px',
          padding: '2px'
        }}
        xs={12}
      >
        <Grid md={12} xl={12} xs={12}>
          {headerProject()}
        </Grid>
      </Grid>
    );
  };

export default StepDetailProjects;
